var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { buildInitialState } from './initial-state';
import { buildCampaignStateFromApiData } from '../model-mapping/mapper';
export var resetCampaign = function (state, action) {
    return buildInitialState({
        session: action.payload.session,
    });
};
export var resetFieldsToInitialState = function (state, action) {
    return __assign(__assign({}, state), { editableFields: buildInitialState({ session: action.payload.session }).editableFields });
};
export var populateFieldsFromApiCampaign = function (state, action) {
    return buildCampaignStateFromApiData({
        campaign: action.payload.campaign,
        session: action.payload.session,
    });
};
export var setEditableFieldValue = function (state, action) {
    var nextState = cloneDeep(state);
    if (state.canEdit) {
        var _a = action.payload, name_1 = _a.name, value = _a.value;
        var didCustomScheduleChange = name_1 === 'usesCustomSchedule';
        if (didCustomScheduleChange) {
            var usesCustomSchedule = value;
            if (usesCustomSchedule) {
                nextState.editableFields.frequency.value = 'one-time';
                nextState.editableFields.sendTime.value = '12:00';
                nextState.editableFields.sendDate.value = moment(new Date()).format(state.editableFields.dateFormat.value);
                nextState.editableFields.endDate.value = null;
                nextState.editableFields.dayOfWeek.value = 'SU';
                nextState.editableFields.dayOfMonth.value = '1';
            }
            else {
                nextState.editableFields.frequency.value = null;
                nextState.editableFields.sendTime.value = null;
                nextState.editableFields.sendDate.value = null;
                nextState.editableFields.endDate.value = null;
                nextState.editableFields.dayOfWeek.value = null;
                nextState.editableFields.dayOfMonth.value = null;
            }
        }
        nextState.editableFields[action.payload.name].value = action.payload.value;
        nextState.editableFields[action.payload.name].error = undefined;
    }
    return nextState;
};
export var setEditableFieldError = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.editableFields[action.payload.name].error = action.payload.error;
    return nextState;
};
export var clearEditableFieldError = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.editableFields[action.payload.name].error = undefined;
    return nextState;
};
export var clearAllEditableFieldErrors = function (state) {
    var nextState = cloneDeep(state);
    Object.keys(nextState.editableFields).forEach(function (key) {
        nextState.editableFields[key].error = undefined;
    });
    return nextState;
};
export var setInitStatus = function (state, action) {
    return __assign(__assign({}, state), { isInitialized: action.payload.didInitialize, isNewCampaign: action.payload.isNewCampaign, isDraft: action.payload.isDraft });
};
export var setIsProcessing = function (state, action) {
    return __assign(__assign({}, state), { isProcessing: action.payload, isDraft: false });
};
export var setMetadata = function (state, action) {
    var nextState = cloneDeep(state);
    var validation = action.payload.metadata.validation;
    var email = validation.email, push = validation.push, sms = validation.sms;
    var _a = email.fields, emailBody = _a.body, emailSubject = _a.subject, emailTitle = _a.title;
    var _b = push.fields, pushBody = _b.body, pushTitle = _b.title.content;
    var smsBody = sms.fields.body;
    nextState.editableFields.emailBodyLimit.value = emailBody.maxLength;
    nextState.editableFields.emailTitleLimit.value = emailTitle.maxLength;
    nextState.editableFields.emailSubjectLimit.value = emailSubject.maxLength;
    nextState.editableFields.pushBodyLimit.value = pushBody.maxLength;
    nextState.editableFields.pushTitle.value = pushTitle;
    nextState.editableFields.smsBodyLimit.value = smsBody.maxLength;
    nextState.editableFields.smsBodySuffix.value = smsBody.suffix;
    return nextState;
};
